import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import userManager from "../../../utils/oidcUserManager";

export const SidebarRight = ({
  logoutClick,
  user,
}: {
  logoutClick: () => void;
  user: any;
}) => {
  return (
    <>
      <div className="h-100">
        <div className="pb-5">
          <h3 className="font-weight-bold m-0">Profilo Utente</h3>
        </div>

        <div className="d-flex h-100">
          <div className="d-flex flex-column justify-content-between h-100 w-100">
            <div>
              <a
                href="#"
                className="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
              >
                {user?.fullname}
              </a>
              <div className="navi mt-2">
                <a href="#" className="navi-item">
                  <span className="navi-link p-0 pb-2">
                    <span className="navi-icon mr-1">
                      <span className="svg-icon-lg svg-icon-primary">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Mail-notification.svg"
                          )}
                        ></SVG>
                      </span>
                    </span>
                    <span className="navi-text text-muted text-hover-primary">
                      {user?.email}
                    </span>
                  </span>
                </a>
              </div>
            </div>

            <div className="mt-4 d-flex justify-content-between">
              <a
                className="btn btn-primary mr-2"
                //id="kt_quick_user_close_button"
                // onClick={() => {
                //   window.location.href = userManager.settings.authority + "/Identity/Account/Manage";
                // }}
                href={
                  userManager.settings.authority + "/Identity/Account/Manage"
                }
                target="_blank"
              >
                Impostazioni Account
              </a>
              <button
                className="btn btn-light-primary btn-bold"
                style={{
                  float: "right",
                  paddingLeft: "2rem",
                  paddingRight: "2rem",
                }}
                onClick={logoutClick}
              >
                Esci
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
